import React from "react";
import { useAuth } from "../context/AuthContext";
import { useMonth } from "../context/MonthContext";
import { MONTH_NAMES } from "../constants";

const Header: React.FC = () => {
  const { user, isLoggedIn, logout } = useAuth();
  const { selectedMonth, setSelectedMonth, currentYear, setCurrentYear } = useMonth();

  const handleLogout = async () => {
    if (window.confirm("确定要退出登录吗？")) {
      await logout();
    }
  };

  const handleDoubleClick = async () => {
    if (isLoggedIn && window.confirm("确定要退出登录吗？")) {
      await logout();
    }
  };

  const handlePrevMonth = () => {
    if (selectedMonth === 0) {
      setCurrentYear(currentYear - 1);
      setSelectedMonth(11);
    } else {
      setSelectedMonth(selectedMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (selectedMonth === 11) {
      setCurrentYear(currentYear + 1);
      setSelectedMonth(0);
    } else {
      setSelectedMonth(selectedMonth + 1);
    }
  };

  return (
    <header className="text-center mb-12 pt-2 relative">
      {isLoggedIn && (
        <div className="flex justify-end mb-4">
          <button
            onClick={handleLogout}
            className="absolute top-0 right-0 lg:top-[32px] lg:right-[32px] bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-1 rounded-lg text-sm transition-colors duration-200 z-10"
          >
            退出
          </button>
        </div>
      )}
      <h1
        className="text-3xl font-bold text-gray-800 cursor-pointer mb-3"
        onDoubleClick={handleDoubleClick}
      >
        {user ? `欢迎回来，${user.username}！` : "我的财务管家"}
      </h1>
      {isLoggedIn && (
        <div className="flex items-center justify-center gap-3 mt-4">
          <button
            onClick={handlePrevMonth}
            className="p-1.5 rounded-lg hover:bg-gray-200 transition-colors text-gray-600"
            aria-label="上个月"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </button>
          <select
            value={currentYear}
            onChange={(e) => setCurrentYear(Number(e.target.value))}
            className="border border-gray-300 rounded-md px-2 py-1 text-sm font-medium text-gray-700 focus:ring-indigo-500 focus:border-indigo-500"
          >
            {Array.from({ length: 10 }, (_, i) => currentYear - 5 + i).map((year) => (
              <option key={year} value={year}>{year}年</option>
            ))}
          </select>
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(Number(e.target.value))}
            className="border border-gray-300 rounded-md px-2 py-1 text-sm font-medium text-gray-700 focus:ring-indigo-500 focus:border-indigo-500"
          >
            {MONTH_NAMES.map((month, index) => (
              <option key={index} value={index}>{month}</option>
            ))}
          </select>
          <button
            onClick={handleNextMonth}
            className="p-1.5 rounded-lg hover:bg-gray-200 transition-colors text-gray-600"
            aria-label="下个月"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
